/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';
import { Card } from '@one-thd/sui-atomic-components';
import { SpecialBuyBanner } from '@thd-olt-component-react/special-buy-banner';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from './context/HomepageContext';

const { string } = proptypes;

export function SpecialBuyOfTheWeek({ id }) {
  const { defaultVariables } = useContext(QueryContext);
  const { defaultCardClass, isB2C } = useContext(HomepageContext);

  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant
      === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <ErrorBoundary name="sbotw">
      <QueryProvider
        cacheKey={`${id}-sbotw`}
        defaultVariables={newDefaultVariables}
      >
        <Card
          id={`sbotw-php-${id}`}
          className={defaultCardClass}
          CardContentProps={{
            className: 'sui-h-full sui-flex sui-flex-col sui-w-full sui-gap-4 sui-p-4'
          }}
        >
          <SpecialBuyBanner specialBuyType="pro" entryId={id} enableRoundedProductImages={isB2C} />
        </Card>
      </QueryProvider>
    </ErrorBoundary>
  );
}

SpecialBuyOfTheWeek.propTypes = {
  id: string,
};

SpecialBuyOfTheWeek.defaultProps = {
  id: undefined,
};
